import { observer } from 'mobx-react-lite'
import { useEffect } from 'react'
import { useDashboardStore } from 'src/feature/dashboard/store/dashboard.store'
import { useLocalizationStore } from 'src/feature/localization/store/localization.store'
import { PageMetrics } from 'src/feature/my-team/component/molecules/PageMetrics'
import { Palette } from 'src/feature/theme/model/Palette'

export const MyLearningMetrics = observer(() => {
  const dashboardStore = useDashboardStore()
  const { translation } = useLocalizationStore()
  const { isLoading } = dashboardStore.getGenericFieldsState('getMyDashboard')

  const pageTranslation = translation.pages.myTeam

  useEffect(() => {
    dashboardStore.getMyDashboard()
  }, [])

  const metrics = [
    {
      label: pageTranslation.metricsHeader.highestRated(),
      value: dashboardStore.myDashboard?.highestRatedSkill || '-',
      icon: 'ArrowUpwardRoundedIcon',
      iconColor: Palette.OLIVE_GREEN,
    },
    {
      label: pageTranslation.metricsHeader.lowestRated(),
      value: dashboardStore.myDashboard?.lowestRatedSkill || '-',
      icon: 'ArrowDownwardRoundedIcon',
      iconColor: Palette.DANGER,
    },
    {
      label: pageTranslation.metricsHeader.avgSkillRating(),
      value: dashboardStore.myDashboard?.avgSkillRating || '-',
    },
    {
      label: pageTranslation.metricsHeader.avgExpectedRating(),
      value: dashboardStore.myDashboard?.avgExpectedSkillRating || '-',
    },
    {
      label: pageTranslation.metricsHeader.validated(),
      value: dashboardStore.myDashboard?.validated || '-',
    },
    {
      label: pageTranslation.metricsHeader.nonValidated(),
      value: dashboardStore.myDashboard?.nonValidated || '-',
    },
    {
      label: pageTranslation.metricsHeader.meetExpectation(),
      value: dashboardStore.myDashboard?.meetExpectation || '-',
    },
    {
      label: pageTranslation.metricsHeader.exceedExpectation(),
      value: dashboardStore.myDashboard?.exceedExpectation || '-',
    },
  ]

  return (
    <PageMetrics
      sx={{
        width: 'auto',
        display: 'grid',
        gridTemplateColumns: {
          xs: 'repeat(1, 1fr)',
          sm: 'repeat(2, 1fr)',
          md: `repeat(${metrics.length}, 1fr)`,
        },
        gap: 15,
      }}
      backgroundColor={'background.paper'}
      metrics={metrics}
      isLoading={isLoading}
    />
  )
})
